'use client';

import { BasicClose } from '../../icons/basic';
import { TextButton } from '../buttons/TextButton';
import { FullScreenDialog, FullScreenDialogClose, FullScreenDialogContent, FullScreenDialogTrigger } from '../dialog/FullScreenDialog';

type Props = {
  videoSrc: string;
  title?: string;
  closeLabel: string;
  children: React.ReactNode; // The trigger element (e.g., video thumbnail)
  testid?: string;
  isYouTube?: boolean;
}

export const VideoDialog = ({
  videoSrc,
  title,
  closeLabel,
  children,
  testid,
  isYouTube = false,
}: Props) => {
  // Helper function to convert YouTube URL to embed URL with autoplay
  const getYouTubeEmbedUrl = (url: string) => {
    const videoIdMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/);
    const videoId = videoIdMatch?.[1];

    return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0` : url;
  };

  return (
    <FullScreenDialog>
      <FullScreenDialogTrigger asChild>
        {children}
      </FullScreenDialogTrigger>

      <FullScreenDialogContent
        className="bg-black left-0 top-0 h-full w-svw p-4 md:p-6"
        data-testid={testid}
      >
        <FullScreenDialogClose className="ml-auto h-10 w-fit">
          <TextButton
            iconRight={BasicClose}
          >
            <div className="text-white">
              {closeLabel}
            </div>
          </TextButton>
        </FullScreenDialogClose>

        <div className="flex h-[calc(100dvh-8rem)] w-full items-center justify-center">
          {isYouTube ? (
            <iframe
              src={getYouTubeEmbedUrl(videoSrc)}
              title={title || 'YouTube Video'}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="size-full"
              style={{
                aspectRatio: '16/9',
              }}
            />
          ) : (
            <video
              src={videoSrc}
              controls
              autoPlay
              className="size-full object-contain"
              style={{
                aspectRatio: '16/9',
              }}
            >
              <track kind="captions" />
              {title && `Video: ${title}`}
            </video>
          )}
        </div>
      </FullScreenDialogContent>
    </FullScreenDialog>
  );
};
